module.exports = __webpack_public_path__ + "img/picture_znks.30461242.png";